export const columnWidth = [154, 118];
